import clsx from 'clsx'
import { CommonUi } from '../../until/text/ui'
import styles from './index.module.scss'
const FooterLayout = () => {
  return <div className={clsx(styles.footer)}>{CommonUi.footer}</div>
}

export default FooterLayout
